import { Create, useForm } from '@refinedev/antd';

import { ShippingLabel } from '@/model/Logistic/ShippingLabel/ShippingLabel';

import ShippingLabelForm from './ShippingLabelsForm/ShippingLabelForm';

export const ShippingLabelCreate = () => {
  const { formProps, saveButtonProps } = useForm<ShippingLabel>({
    successNotification: {
      message: 'Etiqueta de envío creada correctamente',
      type: 'success',
    },
  });

  return (
    <Create saveButtonProps={saveButtonProps}>
      <ShippingLabelForm formProps={formProps} />
    </Create>
  );
};
